// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".63cef91591f7b133f63b3bda0c83b6cf095a361f.chunk.bundle.js";
};